import { deleteCookie, getCookie } from 'stash/utils/cookies';

export const INTRO_FA_INTENT_COOKIE = 'stashIntroFAIntent';

export type IntroIntent = 'retirement' | 'invest';

/** Session cookie written by the intro. Not part of the attribution super cookie. */
export function readIntroFaIntent(): IntroIntent | undefined {
	const value = getCookie(INTRO_FA_INTENT_COOKIE);
	if (value === 'retirement' || value === 'invest') {
		return value;
	}
	return undefined;
}

/** Drop the handoff once the onboarding goal has been submitted. */
export function clearIntroFaIntent(): void {
	deleteCookie(INTRO_FA_INTENT_COOKIE);
}
